import "./BurgerIcon.scss";

const BurgerIcon = () => {
  return (
    <div className="burger-icon">
      <div className="burger-bar"></div>
      <div className="burger-bar"></div>
      <div className="burger-bar"></div>
    </div>
  );
};

export default BurgerIcon;
